import React from 'react';
import { Global, css } from '@emotion/react';

const Fonts: React.FC = () => {
  return (
    <Global
      styles={css`
        @import url('https://fonts.googleapis.com/css2?family=Darumadrop+One&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap')
        /* Any other CSS rules should be placed after the @import statements */
      `}
    />
  );
};

export default Fonts; 